// @core/api/endpoints/project/update_project_member_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProjectMemberResponse,
  UpdateProjectMemberRoleRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Update member role
 * Changes a member's role within the project, adjusting their permissions for project management and item operations.
 */
export async function UpdateProjectMemberRole(
  project_id: string,
  profile_id: string,
  data: UpdateProjectMemberRoleRequest,
  options?: RequestOptions
): Promise<ProjectMemberResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/members/:profile_id/role`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.put<ProjectMemberResponse>(requestPath, data, requestOptions);
}
